module.exports = __webpack_public_path__ + "img/arozzi-logo.1c5bd2bc.png";